<div class="couplet">
  <h2>挽联管理</h2>

  <div class="form-card">
    <div class="form-row">
      <label>类型</label>
      <input v-model="type" type="text" placeholder="请输入类型，例如通用/父亲/母亲" maxlength="50" />
    </div>
    <div class="form-row">
      <label>标题</label>
      <input v-model="title" type="text" placeholder="请输入模板标题" maxlength="100" />
    </div>
    <div class="form-row">
      <label>左联</label>
      <input v-model="leftText" type="text" placeholder="请输入左联内容" maxlength="200" />
    </div>
    <div class="form-row">
      <label>右联</label>
      <input v-model="rightText" type="text" placeholder="请输入右联内容" maxlength="200" />
    </div>
    <button class="primary-btn" @click="handleSave" :disabled="saving">
      {{ saving ? '保存中...' : '新增模板' }}
    </button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <table v-else class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>类型</th>
          <th>标题</th>
          <th>左联</th>
          <th>右联</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="templateList.length === 0">
          <td colspan="7" class="empty-text">暂无挽联模板</td>
        </tr>
        <tr v-else v-for="item in templateList" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.type || '-' }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.left_text }}</td>
          <td>{{ item.right_text }}</td>
          <td>{{ item.created_at || '-' }}</td>
          <td>
            <button class="action-btn delete-btn" @click="handleDelete(item)" :disabled="saving">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
